import { mapToEcommerceItem } from '@pegasus/tracker';
import { PlusBenefitType } from '@pegasus/plus';
import { tracker } from '../track';
import { formatItemName, formatPrice, formattedSimples, getGA4Context, getTrackingDiscountedPrice, toItemAvailability, } from '../../helpers';
export const trackViewItemList = (payload, options) => {
    // eslint-disable-next-line no-unreachable
    try {
        // eslint-disable-next-line camelcase
        const { context, element, itemListName, items, itemsLength, themeHash } = payload;
        tracker.track('GA4-EEC-view_item_list', {
            event_name: 'view_item_list',
            view_item_list: {
                context: context || getGA4Context(),
                element: element || null,
                theme_hash: themeHash || null,
                length: itemsLength || items.length || 0,
                items: items.map((item, index) => {
                    var _a, _b;
                    return mapToEcommerceItem(Object.assign({ affiliation: String(item.categoryId), discount: getTrackingDiscountedPrice({
                            specialPriceInCents: (item === null || item === void 0 ? void 0 : item.specialPrice) || 0,
                            priceInCents: (item === null || item === void 0 ? void 0 : item.price) || 0,
                            savingsPercent: (item === null || item === void 0 ? void 0 : item.savings) || 0,
                            context: 'view_item_list',
                        }), early_access_item: item.plusEarlyAccess || false, index, feature_flag: item.energy_efficiency_class ? 'energy_modal' : null, item_info: item.energy_efficiency_class
                            ? `energy_score_${item.energy_efficiency_class}`
                            : null, item_availability: toItemAvailability(item.stockStatus), item_brand: item.brandCode, item_id: item.sku, item_list_name: itemListName || null, item_name: formatItemName(item), price: formatPrice(item.specialPrice), product_gender: (item.gender || []).toString() ||
                            null, promotion_id: item.campaignIdentifier, size_availability: formattedSimples(item, 'filterValue'), plus_exclusive: ((_a = item === null || item === void 0 ? void 0 : item.plusBenefit) === null || _a === void 0 ? void 0 : _a.type) === PlusBenefitType.Exclusive }, (_b = options === null || options === void 0 ? void 0 : options.customMapper) === null || _b === void 0 ? void 0 : _b.call(options, item)));
                }),
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `view_item_list` failed.', e);
    }
};
